<template>
  <div class="slots">
    <van-popup v-model="showPop" round :style="{width:'80%'}" :close-on-click-overlay="false" get-container="body">
      <div class="content">
        <van-form 
          :show-error-message="false" 
          validate-trigger="onSubmit" 
          validate-first
          input-align="right"
          ref="form"
          class="form"
        >
          <van-field 
            required  
            label="背景图"
            v-model="resultPage.resultBackImg"
            :rules="[{ required: true, message: '请上传背景图' }]"
          >
            <template #input>
              <van-uploader
                :max-count="1" 
                :before-read="beforeImgUpload" 
                :fileList="resultPage.resultBackImgArr" 
                :after-read="(e) => uploadImg(e, 'resultBackImg')"
                @delete="(e) => deleteImg(e,'resultBackImg')"
              />
            </template>
          </van-field>
          <van-field 
            required  
            label="左下角修饰"
            v-model="resultPage.embellishImg"
            :rules="[{ required: true, message: '请上传左下角修饰图' }]"
          >
            <template #input>
              <van-uploader
                :max-count="1" 
                :before-read="beforeImgUpload" 
                :fileList="resultPage.embellishImgArr" 
                :after-read="(e) => uploadImg(e, 'embellishImg')"
                @delete="(e) => deleteImg(e,'embellishImg')"
              />
            </template>
          </van-field>
          <van-field 
            required  
            label="内容图"
            v-model="resultPage.contentImg"
            :rules="[{ required: true, message: '请上传内容图' }]"
          >
            <template #input>
              <van-uploader
                :max-count="1" 
                :before-read="beforeImgUpload" 
                :fileList="resultPage.contentImgArr" 
                :after-read="(e) => uploadImg(e, 'contentImg')"
                @delete="(e) => deleteImg(e,'contentImg')"
              />
            </template>
          </van-field>
          <div class="img-box">
            <p class="title">轮播图</p>
            <van-uploader
              :max-count="100" 
              :before-read="beforeImgUpload" 
              :fileList="resultPage.rollingsArr" 
              :after-read="(e) => uploadImg(e, 'rollings')"
              @delete="(e) => deleteImg(e, 'rollings')"
            />
          </div>
          <van-field 
            required  
            label="全景按钮"
            v-model="resultPage.panoramaBtnImg"
            :rules="[{ required: true, message: '请上传全景按钮图' }]"
          >
            <template #input>
              <van-uploader
                :max-count="1" 
                :before-read="beforeImgUpload" 
                :fileList="resultPage.panoramaBtnImgArr" 
                :after-read="(e) => uploadImg(e, 'panoramaBtnImg')"
                @delete="(e) => deleteImg(e,'panoramaBtnImg')"
              />
            </template>
          </van-field>
          <van-field 
            required  
            label="方案按钮"
            v-model="resultPage.schemeBtnImg"
            :rules="[{ required: true, message: '请上传方案按钮图' }]"
          >
            <template #input>
              <van-uploader
                :max-count="1" 
                :before-read="beforeImgUpload" 
                :fileList="resultPage.schemeBtnImgArr" 
                :after-read="(e) => uploadImg(e, 'schemeBtnImg')"
                @delete="(e) => deleteImg(e,'schemeBtnImg')"
              />
            </template>
          </van-field>
          <van-field
            required
            readonly
            clickable
            right-icon="arrow"
            v-model="resultPage.question"
            label="触发题目"
            placeholder="请选择"
            :rules="[{ required: true, message: '请选择触发题目' }]"
            @click="changePicker(1)"
          />
          <van-field
            required
            readonly
            clickable
            right-icon="arrow"
            v-model="resultPage.answer"
            label="触发答案"
            placeholder="请选择"
            :rules="[{ required: true, message: '请选择触发答案' }]"
            @click="changePicker(2)"
          />
          <van-field
            required
            readonly
            clickable
            right-icon="arrow"
            v-model="resultPage.styleType"
            label="风格类型"
            placeholder="请选择"
            :rules="[{ required: true, message: '请选择风格类型' }]"
            @click="isStyleType = true"
          />
        </van-form>
        <div class="footer">
          <div class="button cancel" @click="cancel">取消</div>
          <div class="button" @click="submit">保存</div>
        </div>
         <div style="height:66px"></div>
      </div>
    </van-popup>
    <van-popup v-model="isPicker" position="bottom" get-container="body" >
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
    <van-popup v-model="isStyleType" position="bottom" get-container="body" >
      <van-picker
        show-toolbar
        :columns="styleType"
        @confirm="onConfirmStyle"
        @cancel="onCancelStyle"
      />
    </van-popup>
  </div>
</template>

<script>
import _ from 'loadsh'
export default {
  props: {
    isResult: {
      type: Boolean,
      default: false
    },
    resultPage: {
      type: Object,
      default() {
        return {}
      }
    },
    questionAll: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    showPop: {
      get() {
        return this.isResult
      },
      set(val) {
        this.$emit('update:isResult', val)
      }
    },
    from() {
      return this.$route.query.from
    }
  },
  data() {
    return {
      isUploadImg: false,
      isPicker: false,
      isStyleType: false,
      changeType: 1,
      columns: [],
      styleType: [
        {text: '极简风格', link: '6bd44990-f5e6-46dd-9449-90f5e6f6dd74'},
        {text: '轻奢风格', link: 'd96498b1-4c6b-4979-a498-b14c6bb9794e'},
        {text: '北欧风格', link: 'c952a709-ecae-41ea-92a7-09ecaeb1eaf9'},
        {text: '中式风格', link: '12f3f1a8-f11a-46a4-b3f1-a8f11af6a442'},
      ],
      debounce: _.debounce(this.checkParames,1000)
    }
  },
  
  methods: {
    onCancel() {
      this.isPicker = false
    },
    beforeImgUpload(file) {
      const acceptTypes = ['image/png', 'image/jpeg', 'image/gif'];
      if (!acceptTypes.includes(file.type)) {
        this.$toast('请上传png、jpg或gif格式图片');
        return false;
      }
      return true;
    },
    uploadImg(e, field) {
      this.uploadImgFn(e, field)
    },
    uploadImgFn(e, field) {
      this.isUploadImg = true
      const currentFile = {
        url: '',
        status:'uploading',
        message: '上传中...'
      }
      this.resultPage[`${field}Arr`].push(currentFile)
      this.$api.common.uploadImg(e.file)
        .then(({data}) => {
          if (data && data[0]) {
            const fileUrl = data[0].fileUrl;
            currentFile.url = fileUrl
            if (field == 'rollings') {
              this.resultPage.rollings.push(fileUrl)
            }else {
              this.resultPage[field] = fileUrl
            }
            currentFile.status = 'done'
            delete currentFile.status
            delete currentFile.message
            this.isUploadImg = false
          }
        })
        .catch(err => {
          this.currentFile[field] = []
          this.currentFile[`${field}Arr`] = ''
      });
    },
    deleteImg(e,field) {
      if (field == 'rollings') {
        let index =  this.resultPage.rollingsArr.findIndex((item) => item.url === e.url)
        this.resultPage.rollingsArr.splice(index, 1)
        this.resultPage.rollings.splice(index, 1)
      }else {
        this.resultPage[field] = ''
        this.resultPage[`${field}Arr`] = []
      }
    },
    changePicker(type) {
      this.changeType = type
      if (type == 1) {
        this.columns = this.questionAll
      }else {
        this.columns = ['答案A', '答案B','答案C', '答案D']
      }
      this.isPicker = true
    },
    onConfirm(e) {
      if (this.changeType == 1) {
        this.resultPage.question = e
      }else {
        this.resultPage.answer = e
      }
      this.isPicker = false
    },
    onCancel() {
      this.isPicker = false
    },
    onConfirmStyle(e) {
      const { text, link} = e
      this.resultPage.styleType = text
      this.resultPage.styleLink = link
      this.isStyleType = false
    },
    onCancelStyle() {
      this.isStyleType = false
    },
    checkParames() {
      // 图片上传中
      if (this.isUploadImg) return
      this.$refs.form.validate().then(async res => {
          if (!this.resultPage.rollings.length) {
            this.$toast('请上传轮播图');
          }else {
            if (this.from == 'manager') {
              const {activityId,id=''} = this.resultPage
              const res = await this.$api.typeTest.saveStylePage({
                id,
                activityId,
                pageType: 'result',
                pageMap:this.resultPage
              })
              this.resultPage.id = res.data ? res.data : id
            }
            this.$emit('resultPageSaveSuccess', this.resultPage)
            this.showPop = false
            this.$toast('保存成功');
          }
        }).catch(err => {
          this.$toast(err[0].message);
        })
    },
    submit() {
      this.debounce()
    },
    cancel() {
      this.showPop = false
    },
  },
  mounted() {},
}
</script>

<style lang="stylus" scoped>
.content {
  .form {
    height: 70vh;
    overflow: hidden;
    overflow-y: auto;
    .img-box {
      padding: 10px 16px;
      .title {
        position relative
      }
      .title::before {
        position: absolute;
        left: -8px;
        color: #ee0a24;
        font-size: 14px;
        content: '*';
      }
    }
  }
  .tips {
    font-size: 10px;
    color: #bbb;
    margin: 6px 0 6px 10px;
  }
  .serial-no {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #606266;
    font-weight: 600;
    height: 30px;
    margin: 0 15px;
    .replace {
      color: #ff6b31;
    }
  }
  .footer {
    box-sizing: border-box
    position absolute;
    left 0
    bottom 0
    height 60px
    width 100%
    display: flex
    align-items: center
    justify-content: space-around
    padding-bottom constant(safe-area-inset-bottom)
    padding-bottom env(safe-area-inset-bottom)
    border-bottom-left-radius: 16px
    border-bottom-right-radius: 16px
    background-color #fff;
    .button {
      padding 10px 40px
      border 1px solid $mainTextColor
      border-radius: 8px
      color #fff
      background-color: $mainTextColor
    }
    .cancel {
      color $mainTextColor
      background: #fff;
    }
  }
  .h5-cropper {
    position: absolute;
    left: -1000px;
    background: red;
  }
}
</style>